import styled from 'styled-components'

const StyledIngredientsCellWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`

export default StyledIngredientsCellWrapper
